<template>
    <div class="box">
      <article class="media">

        <div class="media-left">
          <figure class="image is-64x64">
            <img :src="post.university.image" alt="Image">
          </figure>
        </div>

        <div class="media-content">
          <div class="content">
            <p>
              <strong>{{post.university.name}}</strong>
              <small><time :title="this.localeString">{{this.localeDateString}}</time></small>

              <b-tag v-if="post.highlightedProject" type="is-success">
                  <b-icon icon="star" size="is-small"></b-icon>
                  Project Spotlight
              </b-tag>

              <br>
              {{post.text}}
            </p>

            <div v-if="post.highlightedProject">
                <router-link :to="projectRouterLink">
                    <article class="media">

                      <div class="media-left">
                        <figure class="image is-128x128">
                          <img :src="highlighedProjectImage" alt="Image">
                        </figure>
                      </div>

                      <div class="media-content">
                        <div class="content">
                          <p>
                            <strong>{{post.highlightedProject.name}}</strong>
                            <br>
                            {{post.highlightedProject.pitch}}
                          </p>
                        </div>
                      </div>

                    </article>
                </router-link>
            </div>

          </div>

          <!-- <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item" aria-label="reply">
                <b-icon icon="reply"></b-icon>
              </a>
              <a class="level-item" aria-label="retweet">
                <b-icon icon="retweet"></b-icon>
              </a>
              <a class="level-item" aria-label="like">
                <b-icon icon="heart"></b-icon>
              </a>
            </div>
          </nav> -->

        </div>

      </article>
    </div>
</template>

<style scoped>
.box { width: 85%; }
a > .media { color: #4a4a4a; }
article span.tag { float: right; }
</style>

<script>
export default {
  name: 'Post',
  props: ['post', 'highlighedProjectImage'],
  data () {
    return {
      projectRouterLink: ''
    }
  },
  computed: {
    localeString: function() { return (new Date(this.post.createdAt)).toLocaleString(); },
    localeDateString: function() { return (new Date(this.post.createdAt)).toLocaleDateString(); },
  },
  mounted: function() {
    if(this.post.highlightedProject) {
      this.projectRouterLink = '/project/' + this.post.highlightedProject.id;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Post.vue